module.exports = require("tss-react/mui");